import * as React from "react";
import SelectField from "components/form/select-field";
import { formatMessage } from "lib/globalize-util";
import { MenuItem } from "material-ui";
import moment from "moment";
import { DELIVERY_WINDOW_NONE, DELIVERY_WINDOW_SELECT_DATE } from "constants/delivery-window-types";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import { deliveryWindowDisplayName } from "./catalog-delivery-windows";
import { themeOptions } from "styles/theme";

const styles = {
    base: {
        width: "256px",
    },
    required: {
        border: `1px solid ${themeOptions.palette.primary1Color}`,
        borderRadius: "4px",
    },
    requiredLabel: {
        fontWeight: "bold",
    },
};

interface IProps {
    deliveryWindowEntities: any;
    onDeliverWindowChange: (deliveryWindow) => void;
    value?: string;
    fetchingWindows?: boolean;
    scope: any;
    requireCatalogDates: boolean;
    isNewModalEnabled?: boolean;
}

export class DeliveryWindows extends React.PureComponent<IProps, any> {
    private style = merge(
        $(" .requiredWarning", {
            color: themeOptions.palette.primary1Color,
        }),
        $(" .requiredWarning:before", {
            content: "*",
        }),
    );

    render() {
        const {
            value,
            deliveryWindowEntities,
            fetchingWindows,
            scope,
            requireCatalogDates,
            isNewModalEnabled = false,
        } = this.props;
        const minimumDeliveryWindow = scope.brand.getPreference("minimum_delivery_window");
        let deliveryWindows = [];
        if (deliveryWindowEntities) {
            const filteredWindows = deliveryWindowEntities.filter((deliveryWindow) => {
                const cutoffDay = moment.utc().add(minimumDeliveryWindow, "days");
                const deliveryEnd = moment.utc(deliveryWindow.ship_end, "YYYY-MM-DD");

                return deliveryEnd.isSameOrAfter(cutoffDay, "day");
            });
            deliveryWindows = filteredWindows.map((deliveryWindow) => {
                const name = deliveryWindowDisplayName(deliveryWindow);
                return (
                    <MenuItem key={deliveryWindow._id} value={deliveryWindow._id} primaryText={name} data-test={name} />
                );
            });
        }

        const missingDatesWhenBrandIsEnforcing = requireCatalogDates && value === DELIVERY_WINDOW_NONE;

        return (
            <div {...this.style} style={isNewModalEnabled ? { width: "100%" } : styles.base}>
                <SelectField
                    fullWidth={isNewModalEnabled}
                    width={isNewModalEnabled ? "100%" : "280px"}
                    large={true}
                    label={formatMessage("Delivery")}
                    name="delivery-window-selector"
                    data-test={DATATEST.CATALOG.DELIVERY_SELECTOR}
                    disabled={fetchingWindows}
                    loading={fetchingWindows}
                    value={value}
                    onChange={this.handleChange}
                    inputStyle={missingDatesWhenBrandIsEnforcing ? styles.required : null}
                    labelStyle={missingDatesWhenBrandIsEnforcing ? styles.requiredLabel : null}
                >
                    {!requireCatalogDates && (
                        <MenuItem
                            key={DELIVERY_WINDOW_NONE}
                            value={DELIVERY_WINDOW_NONE}
                            data-test="none"
                            primaryText={formatMessage("None")}
                        />
                    )}
                    {deliveryWindows}
                    <MenuItem
                        key={DELIVERY_WINDOW_SELECT_DATE}
                        value={DELIVERY_WINDOW_SELECT_DATE}
                        primaryText={formatMessage("Choose Date Range")}
                        data-test="choose-date-range"
                    />
                </SelectField>
                {missingDatesWhenBrandIsEnforcing && (
                    <div className="requiredWarning">{formatMessage("Dates are required")}</div>
                )}
            </div>
        );
    }

    private handleChange = (e, index, value) => {
        const { onDeliverWindowChange } = this.props;
        onDeliverWindowChange(value);
    };
}
